import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { Link, graphql, StaticQuery } from "gatsby";

import "./header-dropdown.scss";

const HeaderDropdown = ({
	placeholder,
	options,
	link,
	data,
	language,
	gardensOptions,
}) => {
	const langs = data.lang.nodes[0].languages;

	const [open, setOpen] = useState(false);

	const showDropdown = (e) => setOpen(true);
	const hideDropdown = (e) => setOpen(false);
	// const toggleDropdown = (e) => setOpen(!open);

	const handleScroll = (e) => {
		setOpen(false);
	};

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
	}, [handleScroll]);

	// Touch controls outside component
	// function touchOutsideListener(ref) {
	//   useEffect(() => {
	//     function handleClickOutside(event) {
	//       if (ref.current && !ref.current.contains(event.target)) {
	//         hideDropdown();
	//       }
	//     }
	//     window.addEventListener("touchend", handleClickOutside);
	//     return () => {
	//       window.removeEventListener("touchend", handleClickOutside);
	//     };
	//   }, [ref]);
	// }

	const wrapperRef = useRef(null);
	// touchOutsideListener(wrapperRef);

	return (
		<div
			className={classNames(`dropdown`, {
				[`dropdown--active`]: open,
				[`dropdown--language`]: language,
			})}
			onMouseOver={showDropdown}
			onMouseLeave={hideDropdown}
			onTouchEnd={showDropdown}
			ref={wrapperRef}
		>
			<span className="dropdown__placeholder">{placeholder}</span>
			<ul
				className={classNames(`dropdown__list`, {
					[`dropdown__list--active`]: open,
				})}
			>
				{!language &&
					options?.map((option, index) => (
						<li key={index} className="dropdown__list-item">
							{link ? (
								<Link to={option.url}>
									{option.label}{" "}
									{option.city && (
										<span> - {option.city}</span>
									)}
								</Link>
							) : (
								<a
									href={option.url}
									target="_blank"
									rel="noopener noreferrer nofollow"
								>
									{option.label}{" "}
									{option.city && (
										<span> - {option.city}</span>
									)}
								</a>
							)}
						</li>
					))}
				{gardensOptions &&
					gardensOptions?.map((item, index) => (
						<li key={index} className="dropdown__list-item">
							<a
								href={item.url}
								target="_blank"
								rel="noopener noreferrer nofollow"
							>
								{item.tekst}
							</a>
						</li>
					))}
				{language &&
					langs.map((item, index) => {
						return (
							item.slug !== language && (
								<li key={index} className="dropdown__list-item">
									<Link
										to={`${
											item.slug === "pl"
												? "/"
												: `/${item.slug}`
										}`}
									>
										{item.slug}
									</Link>
								</li>
							)
						);
					})}
			</ul>
		</div>
	);
};
export default function HeaderDropdownStatic(props) {
	return (
		<StaticQuery
			query={graphql`
				{
					lang: allWp {
						nodes {
							languages {
								slug
							}
						}
					}
				}
			`}
			render={(data) => <HeaderDropdown data={data} {...props} />}
		/>
	);
}
